/* eslint-disable @typescript-eslint/no-explicit-any */
import { getErrorMessage } from '@juvare/widget-ui/Utils';
export function buildAlertTab(props, params) {
    const children = [
        {
            type: 'form.select',
            key: ((params === null || params === void 0 ? void 0 : params.prefix) ? params.prefix + '.' : '') + 'alert.severity',
            label: 'Alert Severity',
            values: [
                { value: 'info', label: 'Info' },
                { value: 'error', label: 'Error' },
                { value: 'warning', label: 'Warning' },
                { value: 'success', label: 'Success' },
            ],
            style: {
                width: 300,
            },
        },
        {
            type: 'form.text',
            key: ((params === null || params === void 0 ? void 0 : params.prefix) ? params.prefix + '.' : '') + 'alert.message',
            label: 'Alert Message',
        },
    ];
    if (params === null || params === void 0 ? void 0 : params.custom) {
        children.push({
            type: 'form.text',
            key: (params.prefix ? params.prefix + '.' : '') + 'alert.custom',
            label: 'Custom Alert JavaScript Function',
            emptyAsNull: true,
            multiline: true,
            rows: 6,
            style: {
                monospace: true,
            },
            validate: {
                custom: (value) => {
                    if (value) {
                        try {
                            Function('"use strict"; return (function(value, handler) { ' + value + '; })')();
                        }
                        catch (error) {
                            return getErrorMessage(error);
                        }
                    }
                    return undefined;
                },
            },
        });
    }
    if (params === null || params === void 0 ? void 0 : params.children) {
        children.push(...params.children);
    }
    const onLoad = (data) => {
        if (params === null || params === void 0 ? void 0 : params.onLoad) {
            data = params.onLoad(data);
        }
        return data;
    };
    const onSubmit = (data) => {
        const alertData = (params === null || params === void 0 ? void 0 : params.prefix) ? data[params.prefix] : data;
        if (alertData.alert && Object.keys(alertData).length === 0) {
            delete alertData.alert;
        }
        if (params === null || params === void 0 ? void 0 : params.onSubmit) {
            data = params.onSubmit(data);
        }
        return data;
    };
    return { label: 'Alert', children, onLoad, onSubmit };
}
